var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('div',[_c('button',{on:{"click":_vm.batchQuery}},[_vm._v("结果上传平台")])])]),_c('div',{attrs:{"id":"shadow_ct"}})])}
var staticRenderFns = []

export { render, staticRenderFns }